import { API_BASE_URL } from '../constants/suggestions';

export const queryAPI = async (
  question,
  chatHistory,
  token,
  conversationId,
  onUpdate,
  options = {}
) => {
  const { signal } = options;
  const payload = {
    question,
    conversation_id: conversationId,
    chat_history: chatHistory.map(m => ({
      role: m.role === 'bot' ? 'assistant' : 'user',
      content: m.content
    }))
  };

  const response = await fetch(`${API_BASE_URL}/query`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream',
      'Authorization': `Bearer ${token}`,
    },
    signal,
    body: JSON.stringify(payload),
  });
  
  if (!response.ok) {
    const errorText = await response.text();
    console.error("Server error response:", errorText);
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let currentEvent = null;

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';

      for (const line of lines) {
        if (line.startsWith('event:')) {
          currentEvent = line.substring(6).trim();
        } else if (line.startsWith('data:')) {
          const dataStr = line.substring(5).trim();
          
          if (currentEvent === 'end_stream') {
            onUpdate?.('end_stream', {});
            continue;
          }
          
          if (dataStr) {
            try {
              const data = JSON.parse(dataStr);
              onUpdate?.(currentEvent, data);
            } catch (e) {
              console.error("Failed to parse JSON from event data:", dataStr, e);
            }
          }
        }
      }
    }
  } catch (error) {
    if (signal?.aborted) {
      try {
        await reader.cancel();
      } catch (_) {
        // Ignore cancellation errors after abort.
      }
    }
    throw error;
  } finally {
    reader.releaseLock?.();
  }
};
